module.exports = __webpack_public_path__ + "img/00-W.9fd0809c.svg";